import React from 'react';
import { Stack, Box} from '@mui/material'

const Emoji = ({ onClick })=>{
    
    return (
        <Stack direction='row'>
            {[ '😀','😍','🤓','🤯'].map((ele,idx)=>(
                <Box onClick={()=> onClick(ele) } sx={{m: .5}} key={idx}>{ele}</Box>

            ))}                        
        </Stack>
    )

}

export default Emoji;